import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-file',
  template: `
    <input type="file"
      class="form-control"
      [attr.accept]="to['accept']"
      [attr.multiple]="to['multiple'] ? true : null"
      (change)="onFileChange($event)" />
  `,
})
export class FormlyFieldFileComponent extends FieldType {
  onFileChange(event: Event): void {

    // console.log('File input changed:', event);
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if (!file) return this.formControl.setValue(null);

    const reader = new FileReader();
    reader.onload = () => {
      const buffer = reader.result as ArrayBuffer;
      const safeFile = new File([new Uint8Array(buffer)], file.name, {
        type: file.type,
        lastModified: file.lastModified,
      });
      this.formControl.setValue(safeFile);
    };
    reader.readAsArrayBuffer(file);
  }
}
